import React from 'react';
import PropTypes from 'prop-types';
import css from './SearchBoxNoResults.scss';

export const SearchBoxNoResults = ({ message }) => (
  <ul>
    <li className={css.base}>{message}</li>
  </ul>
);

SearchBoxNoResults.propTypes = {
  message: PropTypes.string.isRequired,
};
